import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Who the player is at the table: the name and buddy picked in onboarding, so the player's own seat shows
 * a face and a name instead of a bare "You". Per device; nothing leaves it.
 */
export type BuddyId = 'Bot' | 'Cat' | 'Dog' | 'Bird';

interface PlayerLookStore {
  readonly name: string;
  readonly buddy: BuddyId;
  setLook(p: { name?: string; buddy?: BuddyId }): void;
}

export const usePlayerLookStore = create<PlayerLookStore>()(
  persist(
    (set) => ({
      name: '',
      buddy: 'Bot',
      setLook(p) {
        set({ ...(p.name !== undefined ? { name: p.name.trim().slice(0, 20) } : {}), ...(p.buddy ? { buddy: p.buddy } : {}) });
      },
    }),
    { name: 's4k:player-look' },
  ),
);
